import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess';
import _ from 'lodash';
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext';
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Icon, Label } from 'semantic-ui-react';
import { ParentContext } from '../../cnr/contexts/ParentContext';
import { currentHelpers } from '../../redirection/current';
import FullPageWrapper from '../../wrappers/FullPageWrapper';
import Wrapper, { wrapperTypes } from '../../wrappers/Wrapper';
import NoData from '../alerts/NoData';
import { useFcm } from 'global/cnr/contexts/useHelpers/useFcm';
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares';
import { useFavorites } from 'global/cnr/contexts/useHelpers/useFavorites';
import { FrameworkContext } from 'global/cnr/contexts/FrameworkContent';

const icon = 'star'
const iconColor = 'blue'

const _headerTypes = {
  teams: 'teams',
  sports: 'sports',
  districts: 'districts'
}

const UserFavorites = (props) => {

  const { fullPage } = props ?? {}

  const navigate = useNavigate();

  const { updateAppUserFav } = useFavorites()
  const { sendFcm_toTopic } = useFcm()

  const appUserAccess = useAppUserAccess()
  const { isSuperAdminDeveloper } = appUserAccess ?? {}

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { favorites_state, paps_state } = states ?? {}
  const { appUserFavs } = favorites_state ?? {}

  const frameworkContext = useContext(FrameworkContext);
  const { framework_state, framework_handlers } = frameworkContext ?? {}
  const { isMobileDevice, parentProps } = framework_state ?? {}

  const sportsSeasonContext = useContext(SportsSeasonContext);
  const { sportsSeason_state } = sportsSeasonContext ?? {}
  const { teams_info, sportsParents } = sportsSeason_state ?? {}
  const { teams } = teams_info ?? {}
  const { pathViews, rootPaths } = paps_state ?? {}

  const [selectedSection, setSelectedSection] = useState('teams')

  const getCaption = (collectionKey, name) => {
    switch (collectionKey) {
      case 'teams':
      case 'sports':
        return name;
      default:
        return undefined;
    }
  };

  const handleCancel = () => props.handleCancel ? props.handleCancel() : navigate(-1)

  const handlePush = (item) => {
    navigate(item.pathName)
  }

  const handleUpdateFav = (e, favItem) => {
    e.stopPropagation()
    const _favItem = {
      pageKey: favItem?.[selectedSection],
      name: favItem.name,
      pathName: favItem.pathName,
    }
    updateAppUserFav({ eventFavs: appUserFavs, pathViews, favItem: _favItem, favGroup: selectedSection, parentProps })
  }

  const handleUpdateTeamFav = (e, team) => {
    e.stopPropagation()
    const _favItem = {
      pageKey: team._itemKey,
      name: team.name,
      pathName: `${rootPaths.sports}teams/${team._itemKey}`,
    }
    updateAppUserFav({ eventFavs: appUserFavs, pathViews, favItem: _favItem, favGroup: selectedSection, parentProps })
  }

  const handleSendToTopic = (e, fav) => {
    const { caption, name, teams: t, _sports } = fav
    e.stopPropagation()
    sendFcm_toTopic(t, caption + ' Update', caption + ' has been updated')
  }

  const handleSelectedSection = (section) => setSelectedSection(selectedSection === section ? null : section)

  const getNextMatch = (item) => {
    const _nextMatch = teams?.[item?.key]?._nextMatch
    if (_nextMatch) {
      const { startDate, _status } = _nextMatch
      const { matchName } = _status ?? {}
      return <div className='fav-item-match' >
        {startDate && <div style={{ fontSize: '.8rem' }}><Icon style={{ marginRight: '1em' }} name={'calendar'} color={iconColor} />{startDate}</div>}
        {matchName && <div>{matchName}</div>}
      </div>
    } else {
      return <div className='fav-item-match' >
        <div style={{ fontSize: '.8rem' }}><Icon style={{ marginRight: '1em' }} name={'calendar'} color={iconColor} />{'Off Season'}</div>
      </div>
    }
  }

  const fnAlt = (item) => <Icon
    name='heart'
    color='green'
    onClick={(e) => { handleUpdateFav(e, item) }}>
  </Icon>

  const fnSub = (item) => {
    switch (selectedSection) {
      case _headerTypes.teams:
        const { sport } = item
        if (sport) {
          return <div className='sqr-box-sub sports' style={{ display: 'flex', flexDirection: 'column', rowGap: '.5em' }}>
            {sport?.name}
            {pathViews.sports && getNextMatch(item)}
          </div>
        }

    }
  }

  const ims_favs = (favs) => {
    const oc = (item) => handlePush(item)
    return <ItemMenuSquares
      menuItems={favs}
      fn_altContent={fnAlt}
      fn_subContentt={fnSub}
      noItemIcon={selectedSection === _headerTypes.teams ? true : false}
      style={{ padding: '.5em' }}
      onClick={oc}
    ></ItemMenuSquares>
  }

  const ims_header = () => {
    const oc = (item) => handleSelectedSection(item)
    return <ItemMenuSquares
      menuItems={_headerTypes}
      imsType={_imsTypes.menu}
      activeItem={selectedSection}
      style={{ padding: '.5em' }}
      onClick={oc}
    ></ItemMenuSquares>
  }

  const ims_teams = () => {
    const fnAlt_teams = (team) => {
      const selected = appUserFavs?.teams?.[team._itemKey]
      return <Label
        color={selected ? 'green' : 'black'}
        size='mini'
        onClick={(e) => { handleUpdateTeamFav(e, team) }}>
        Follow
      </Label>
    }

    return <ItemMenuSquares
      icon={'users'}
      caption={'All Teams'}
      menuItems={_.sortBy(teams, 'name')}
      imsType={_imsTypes.inline}
      style={{ padding: '.5em', marginTop: '1em' }}
      noItemIcon={true}
      fn_altContent={fnAlt_teams}
    ></ItemMenuSquares>
  }

  const content = () => {
    if (appUserFavs?.[selectedSection]) {
      return <>
        {ims_favs(appUserFavs?.[selectedSection])}
        {selectedSection === _headerTypes.teams && teams && ims_teams()}
      </>
    } else {
      switch (selectedSection) {
        case _headerTypes.teams:
          return teams && ims_teams()

      }

      return <NoData altCaption={'Following'} />
    }
  }

  const container = () => <Wrapper
    topper={ims_header()}
    content={content()}
    wrapperType={wrapperTypes.paddedContent}
    css={{ container: 'app-dark-mode' }}
  ></ Wrapper>

  const fullPageWrapper = () => <FullPageWrapper
    content={container()}
    handleCancel={handleCancel}
    topperCaption={'Following'}
  />

  return fullPage ? fullPageWrapper() : container()

}

export default UserFavorites